import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { FDConfirmationDialog } from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  useScenarioLoadingContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/ScenarioLoadingIndicator/ScenarioLoadingContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMountedGuard from 'Hooks/useMountedGuard';
import KabobMenu from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu';
import OutcomeAccountSelectionKabobItem
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/SummaryCardPicker/AccordionSummaryCard/Content/AccordionSummaryCardWithNestedItems/Content/Summary/OutcomeSummaryKabobMenu/OutcomeAccountSelection';
import DeleteKabobItem from './DeleteKabobItem';
import AdvancedEditKabobItem from './AdvancedEditKabobItem';

const OutcomeSummaryKabobMenu = ({ resource }) => {
  const { refreshPageContentCollection } = usePageContentContext();
  const { setFacetPlanViewLoading, setFacetPlanViewLoadingCompleted } = useScenarioLoadingContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { doWithMountedGuard } = useMountedGuard();
  const [confirmationConfig, _setConfirmationConfig] = useState({});
  const [loading, _setLoading] = React.useState(false);
  const setConfirmationConfig = doWithMountedGuard(_setConfirmationConfig);
  const setLoading = doWithMountedGuard(_setLoading);

  const handleDeleteConfirm = async (e) => {
    e.stopPropagation();
    setLoading(true);
    setFacetPlanViewLoading();
    try {
      if (resource.meta().action('DELETE')) {
        await resource.delete();
      }
    } catch (err) {
      displayErrorMessage(err, err.errors);
      setFacetPlanViewLoadingCompleted();
      setLoading(false);
      return;
    }
    setLoading(false);
    setConfirmationConfig({
      open: false,
    });

    await refreshPageContentCollection();
  };

  const handleOnClose = (e) => {
    e.stopPropagation();
    setConfirmationConfig({
      open: false,
    });
  };

  const handleDeleteOnClick = () => {
    setConfirmationConfig({
      message: 'Removing this item will delete all of its information. This cannot be undone.',
      onConfirm: handleDeleteConfirm,
      onClose: handleOnClose,
      confirmLabel: 'Remove',
      open: true,
      title: 'Are you sure?',
    });
  };

  return (
    <React.Fragment>
      <KabobMenu>
        {pickFunction(resource, {
          [fr.relationships.facetPlanOutcomeWizardNavigation.name]: () => (
            <AdvancedEditKabobItem resource={resource} />
          ),
          [fr.relationships.outcomeAccountSelection.name]: () => (
            <OutcomeAccountSelectionKabobItem resource={resource} />
          ),
          [fr.relationships.default.name]: () => null,
        })}
        {!!resource?.meta()?.action('DELETE')
          && <DeleteKabobItem onClick={() => handleDeleteOnClick()} />
        }
      </KabobMenu>
      <FDConfirmationDialog
        message={confirmationConfig.message ?? ''}
        confirmLabel={confirmationConfig.confirmLabel}
        onConfirm={(e) => confirmationConfig.onConfirm(e)}
        onClose={(e) => confirmationConfig.onClose(e)}
        open={confirmationConfig.open}
        loading={loading}
        title={confirmationConfig.title ?? ''}
      />
    </React.Fragment>
  );
};

OutcomeSummaryKabobMenu.defaultProps = {};

OutcomeSummaryKabobMenu.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default OutcomeSummaryKabobMenu;
